// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
// 角色管理
import Role from '@/views/system/Role';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 商户管理
 */
// 商户管理管理
import Merchant from '@/views/mch/Merchant';
// 绩效模板
import SalaryTemplate from "@/views/mch/SalaryTemplate";
// 奖励模板
import RewardTemplate from "@/views/mch/RewardTemplate";

/**
 * 账务管理
 */
// 记账
import ManualTrans from '@/views/finance/ManualTrans';

/**
 * 员工管理
 */
// 员工管理
import Staff from "../views/staff/Staff";
// 工资
import Wage from "../views/staff/Wage";
//绩效管理
import StaffReward from "../views/staff/StaffReward"
/**
 * 支付管理
 */
// 支付配置
import Config from '@/views/finance/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';



// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
      path: '/mch/Merchant',
      name: '商户管理',
      component: Merchant,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/mch/SalaryTemplate',
      name: '工资模板',
      component: SalaryTemplate,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/mch/RewardTemplate',
      name: '奖励模板',
      component: RewardTemplate,
      meta: {
        requireAuth: true
      }
    },{
      path: '/staff/Staff',
      name: '员工管理',
      component: Staff,
      meta: {
        requireAuth: true
      }

    },{
      path: '/staff/Wage',
      name: '工资',
      component: Wage,
      meta: {
        requireAuth: true
      }

    },{
      path: '/finance/manualTrans',
      name: '交易订单',
      component: ManualTrans,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/user',
      name: '用户管理',
      component: user,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Role',
      name: '角色管理',
      component: Role,
      meta: {
        requireAuth: true
      }
    },{
      path: '/system/Variable',
      name: '系统环境变量',
      component: Variable,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Permission',
      name: '权限管理',
      component: Permission,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/pay/Config',
      name: '支付配置',
      component: Config,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/druid/login',
      name: '监控查询',
      component: druidLogin,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/charts/statistics',
      name: '数据可视化',
      component: statistics,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/staff/staffReward',
      name: '绩效管理',
      component: StaffReward,
      meta: {
        requireAuth: true
      }
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js